import { render, staticRenderFns } from "./ChallengeParentNavigation.vue?vue&type=template&id=6d2a8792&"
import script from "./ChallengeParentNavigation.vue?vue&type=script&lang=js&"
export * from "./ChallengeParentNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports